<template>
  <div class="timeline timeline-mobile" tabindex="0" :style="{ display: selectedDecade === 0 && !timelineTransitioning ? 'none' : 'block' }">
    <h2 class="decade-header" ref="decadeHeader">
      <span>{{ selectedDecade + 's' }}</span>
    </h2>
    <div v-for="item in items" :key="item.ID">
      <img :src="item.main_image" />
      <div class="timeline-copy">
        <h3>{{ item.year }}</h3>
        <h2 v-html="item.the_title"></h2>
        <div v-html="item.the_content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  mounted() {
    this.updateDecadeHeaderWidth();
    if (this.selectedDecade !== 0) {
      this.$el.focus();
    }
    window.addEventListener('resize', this.updateDecadeHeaderWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDecadeHeaderWidth);
  },
  computed: {
    ...mapGetters(['selectedDecade', 'items']),
  },
  methods: {
    ...mapActions(['selectDecade']),
    updateDecadeHeaderWidth() {
      this.decadeHeaderWidth = this.$refs.decadeHeader.clientWidth;
    }
  },
  watch: {
    selectedDecade() {
      this.$el.scrollTop = 0;
      if (this.selectedDecade !== 0) {
        this.$el.focus();
      }
    }
  },
  data() {
    return {
      decadeHeaderWidth: 0,
    };
  }
};
</script>


// WEBPACK FOOTER //
// TimelineMobile.vue?0b0f7d0e